import client from '../client'

export const getFavoritesKey = `${process.env.NEXT_PUBLIC_SEARCH_DOMAIN}/api/Search/GetFavorites`

export async function getFavorites() {
  return client(getFavoritesKey)
}
